
    import { defineComponent } from 'vue'
    import useValidate from '@vuelidate/core'
    import Card from 'primevue/card'
    import InlineMessage from 'primevue/inlinemessage'
    import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'

    export default defineComponent({
        name: 'roles-tab',
        components: {
            InlineMessage,
            Card,
            KnValidationMessages
        },
        emits: ['unlock', 'dataChanged'],
        props: {
            formValues: Object,
            disabledUID: Boolean,
            vobj: Object,
            formInsert: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            formValues: {
                handler: function(values) {
                    this.userDetailsForm = values
                }
            },
            disabledUID: {
                handler: function(value) {
                    this.disableUsername = value
                }
            }
        },
        data() {
            return {
                v$: useValidate() as any,
                userDetailsForm: {} as any,
                defaultRole: null,
                hiddenForm: true as Boolean,
                disableUsername: true as Boolean,
                loading: false as Boolean
            }
        },
        created() {
            this.userDetailsForm = this.formValues
            this.disableUsername = this.disabledUID
        },
        methods: {
            unlockUser() {
                this.$emit('unlock')
            },
            onDataChange(v$Comp) {
                v$Comp.$touch()
                this.$emit('dataChanged')
            }
        }
    })
